<template>
  <div class="page">
    <initio-panel @submit-handler="submitHandler" :errors="errors">
      <template v-slot:title>
        Confirm vehicle address and driver
      </template>
      <template v-slot:sidebar>
        <span style="display:none"></span>
      </template>
    </initio-panel>
  </div>
</template>

<script>

import InitioPanel from '@/components/initio/InitioPanel.vue'
//import InitioDontInsure from '@/components/partials/DontInsure.vue'
import stepSubmit from '@/mixins/stepSubmit.js'
import { mapGetters } from 'vuex'

export default {
  components: {
    InitioPanel,
    //InitioDontInsure
  },
  mixins: [
    stepSubmit
  ],
  mounted () {
    this.$store.dispatch('getSchema', 'alt/vehicle-confirm' )
      .then(response => {
        this.$store.commit('updateSchema', response);
      })
  },
  methods: {
    submitHandler() {
      let context = this;

      this.genericSubmitHandler()
        .then(response => {
          // console.log(response)

          // Get the data backend validation data for the conditional UW question
          if ( response.results.driver_inexperienced_petrol ) {
            this.$store.commit('updateBackendData', {
                'VehicleAlt.Confirm': {
                  driver_inexperienced_petrol: response.results.driver_inexperienced_petrol
                }
              }
            );
          } else {
            this.$store.commit('updateBackendData', {
                'VehicleAlt.Confirm': {
                  driver_inexperienced_petrol: false
                }
              }
            );
          }

          if ( response.results.price_low ) {

            this.$store.commit('updateAnswers',{
              localActiveStep: 'VehicleAlt.Plate',
              answers: {
                vehicle_price_low: response.results.price_low,
                vehicle_price_avg: response.results.price_avg,
                vehicle_price_high: response.results.price_high,
                sum_insured_default: response.results.sum_insured_default,
              }
            });

            this.$store.commit('updateAnswers',{
              localActiveStep: 'VehicleAlt.Quote',
              answers: {
                vehicle_sum_insured_amount: response.results.sum_insured_default,
              }
            });
          }

        }, error => {
          // Don't actually need to log error here, as we show the errors on front-end ( else ends up in sentry )
          context.errors = error;
        });
    }
  },
  data () {
    return {
      errors: [],
      schema: [],
    }
  },
  computed: {
    ...mapGetters({
      currentSession: 'currentSession',
      answers: 'flattenedAnswers',
      client: 'client'
    }),
  },
  beforeMount () {

    // If a new client then default then default vehicle.confirm to 'new-driver' so its already expanded
    const is_new_client = ! this.client.cli_num;

    // If a existing client but no drivers, then default answer to 'new-driver'
    const existing_client_no_drivers = this.client && (!this.client.drivers || this.client.drivers.length === 0);

  }
}

</script>

<style scoped lang="scss">
  
</style>